import {View, StyleSheet} from 'react-native';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Text from '@/components/basic/text';
import React from 'react';
import theme from '@/style';
import {currentBrand} from '@/brands';

export interface HeaderTabProps {
  options: {label: string; value: string}[];
  selectedKey: string;
  onChange?: (v: string) => void;
}

const isAnna = currentBrand.key === 'anna';

const HeaderTab = ({options, selectedKey, onChange}: HeaderTabProps) => {
  return (
    <View
      style={[
        theme.flex.row,
        theme.flex.centerByCol,
        styles.group,
        isAnna && styles.annaGroup,
      ]}>
      {options.map((item, _i) => (
        <NativeTouchableOpacity
          onPress={() => onChange?.(item.value)}
          key={_i}
          style={[
            theme.overflow.hidden,
            styles.itemWrap,
            isAnna && styles.annaItemWrap,
            selectedKey === item.value &&
              (isAnna ? styles.annaItemSelected : styles.itemSelected),
          ]}>
          <View style={[styles.item, isAnna && styles.annaItem]}>
            <Text
              size="medium"
              style={[styles.text, isAnna && styles.annaText]}
              main={selectedKey === item.value}
              blod={selectedKey === item.value}>
              {item.label}
            </Text>
          </View>
        </NativeTouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  group: {
    gap: theme.paddingSize.xs,
  },
  itemWrap: {
    backgroundColor: '#EFF1F7',
  },
  annaGroup: {
    height: 32,
    alignItems: 'flex-end',
  },
  annaItemWrap: {
    borderRadius: 4,
  },
  item: {
    width: 72,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
  },
  annaItem: {
    height: 30,
  },
  annaItemSelected: {
    height: 32,
    borderTopWidth: 2,
    borderColor: theme.basicColor.primary,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundColor: '#EFF1F7',
  },
  itemSelected: {
    borderTopWidth: 2,
    borderColor: theme.basicColor.primary,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    backgroundColor: '#EFF1F7',
  },
  text: {
    fontWeight: '500',
    fontSize: 14,
  },
  annaText: {
    letterSpacing: -0.3,
  },
});

export default HeaderTab;
